import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const es = {
  translation: {
    app: { name: 'Eurobath ERP', subtitle: 'Control operativo de fábrica', version: 'Fase 1' },
    impersonation: {
      viewingAs: 'Viendo como {{name}} ({{user}})',
      readOnly: 'Solo lectura',
      minutesLeft_one: 'queda {{count}} min',
      minutesLeft_other: 'quedan {{count}} min',
      back: 'Volver a Administración',
      start: 'Ver como',
      dialogTitle: 'Ver la aplicación como {{name}}',
      dialogHint: 'Se abre una sesión de solo lectura con sus permisos y su puesto. Podrás volver a Administración en cualquier momento.',
      terminal: 'Terminal',
      terminalAuto: 'El de su puesto (automático)',
      enter: 'Entrar como este trabajador'
    },
    station: {
      endShift: 'Cerrar turno',
      endShiftConfirmShort: 'Toca otra vez para salir',
      endShiftConfirmTouch: 'Toca otra vez para salir',
      endShiftConfirmKey: 'Pulsa Espacio otra vez para salir',
      nav: 'Barra del puesto',
      connected: 'En línea',
      offline: 'Sin conexión',
      noTerminal: 'Sin terminal'
    },
    nav: {
      dashboard: 'Cuadro de mando', operations: 'Operaciones', sales: 'Ventas', salesOrders: 'Pedidos de venta', customers: 'Clientes', kits: 'Kits',
      packaging: 'Embalaje', logistics: 'Logística', warehouse: 'Almacén', warehouseStation: 'Puesto de almacén', products: 'Artículos', families: 'Familias',
      stock: 'Stock', purchasing: 'Compras', suppliers: 'Proveedores', invoices: 'Facturas', purchaseOrders: 'Pedidos de compra', treasury: 'Tesorería', tariff: 'Arancel', currencies: 'Monedas', company: 'Datos de la empresa',
      engineering: 'Ingeniería', models: 'Modelos y BOM', planning: 'Planificación', admin: 'Administración',
      users: 'Usuarios', terminals: 'Terminales', audit: 'Auditoría', settings: 'Ajustes'
    },
    actions: {
      new: 'Nuevo', save: 'Guardar', cancel: 'Cancelar', edit: 'Editar', delete: 'Eliminar', search: 'Buscar',
      filter: 'Filtrar', refresh: 'Actualizar', close: 'Cerrar', confirm: 'Confirmar', back: 'Volver',
      print: 'Imprimir', download: 'Descargar', view: 'Ver', validate: 'Validar', release: 'Liberar',
      scan: 'Escanear', complete: 'Completar', run: 'Ejecutar', logout: 'Cerrar sesión', login: 'Entrar',
      add: 'Añadir', remove: 'Quitar', apply: 'Aplicar', retry: 'Reintentar', upload: 'Subir',
      acknowledge: 'Revisar', resolve: 'Resolver', details: 'Detalle', actions: 'Acciones',
      previous: 'Anterior', next: 'Siguiente', clear: 'Limpiar', language: 'Idioma', theme: 'Tema'
    },
    common: {
      loading: 'Cargando…', noData: 'Sin resultados', all: 'Todos', total: 'Total', units: 'Unidades',
      quantity: 'Cantidad', date: 'Fecha', status: 'Estado', type: 'Tipo', name: 'Nombre', code: 'Código',
      notes: 'Notas', location: 'Ubicación', supplier: 'Proveedor', customer: 'Cliente', model: 'Modelo',
      order: 'Pedido', kit: 'Kit', unit: 'Unidad', price: 'Precio', cost: 'Coste', stock: 'Stock',
      reserved: 'Reservado', available: 'Disponible', incoming: 'Entrante', min: 'Mínimo', required: 'Requerido',
      scanned: 'Escaneado', pending: 'Pendiente', optional: 'Opcional', yes: 'Sí', no: 'No',
      page: 'Página', of: 'de', results: 'resultados', saved: 'Guardado correctamente',
      error: 'Se ha producido un error', requiredField: 'Campo obligatorio', dateFrom: 'Desde', dateTo: 'Hasta'
    },
    login: {
      title: 'Acceso al sistema', subtitle: 'Introduce tus credenciales para acceder al sistema.',
      user: 'Usuario o email', password: 'Contraseña', terminal: 'Terminal', badge: 'Tarjeta',
      withPassword: 'Usuario y contraseña', withBadge: 'Tarjeta QR', badgeHint: 'Escanea tu tarjeta personal',
      submit: 'Entrar', demo: 'Credenciales de demostración',
      feature1: 'Trazabilidad completa por unidad', feature2: 'Stock, kits y embalaje en tiempo real',
      feature3: 'Planificación MRP y alertas de rotura', secure: 'Conexión segura · sesión auditada',
      error: 'No se pudo iniciar sesión'
    },
    dashboard: {
      title: 'Cuadro de mando', subtitle: 'Visión operativa de la fábrica en tiempo real',
      openOrders: 'Pedidos de venta abiertos', pendingUnits: 'Unidades por preparar', inProduction: 'En producción',
      shipmentsToday: 'Expediciones hoy', stockValue: 'Valor del stock', criticalAlerts: 'Alertas críticas',
      lowStock: 'Artículos bajo mínimo', pipeline: 'Estado de los pedidos de venta', production: 'Unidades creadas (14 días)',
      alerts: 'Alertas de planificación', activity: 'Actividad reciente', noActivity: 'Sin actividad reciente',
      viewPlanning: 'Ver planificación'
    },
    kpis: { days14: 'Últimos 14 días', shift: 'Turno actual', live: 'En vivo' },
    warehouse: {
      title: 'Puesto de almacén',
      subtitle: 'Kits pendientes, recepción e impresión en una sola pantalla vertical',
      queue: 'Cola de preparación',
      pendingCount: '{{count}} en cola',
      agedCount: '{{count}} con retraso',
      ageAlert: 'El kit {{kit}} lleva {{hours}} h sin prepararse',
      ageAlertMany: '{{count}} kits han superado el umbral de antigüedad y están marcados en la cola',
      aged: 'retraso',
      empty: 'No hay kits pendientes',
      emptyHint: 'Cuando un pedido libere unidades aparecerán aquí.',
      missingPieces: '{{count}} piezas pendientes',
      ofLines: '{{done}}/{{total}} líneas listas',
      prepare: 'Preparar kit',
      pickHint: 'Elige un kit de la cola para prepararlo.',
      shortcuts: 'Accesos rápidos',
      reception: 'Recepción de compras',
      printing: 'Impresión de etiquetas',
      back: 'Volver a la cola',
      age: 'Antigüedad',
      linesPending: '{{count}} piezas sin completar',
      scanLabel: 'Escanea el EAN o el SKU de la pieza',
      scanPlaceholder: 'EAN o SKU…',
      pieces: 'Piezas del kit',
      ready: 'Completa',
      missingQty: 'Faltan {{missing}}',
      lineComplete: 'Pieza completa',
      linePartial: 'Añadida, todavía faltan unidades',
      scannedLine: '{{sku}} · {{scanned}} / {{required}} · faltan {{pending}}',
      scanRejected: 'Escaneo rechazado',
      scanExcess: '{{message}} Pedido: {{required}} · faltan: {{pending}} ({{sku}})',
      invalidQty: 'La cantidad no es válida: escribe un número mayor que cero (puedes usar coma, 2,4).',
      overScanned: 'Escaneado por encima de lo requerido',
      overScannedDetail: '{{sku}}: {{scanned}} de {{required}}. Revisa la pieza antes de continuar.',
      excessShort: '+{{qty}} de más',
      excessBlockTitle: '{{count}} pieza(s) escaneadas por encima de lo requerido',
      excessBlockDetail: 'Al cerrar el kit se consumirán {{qty}} unidades de más del stock. Revisa las piezas marcadas antes de continuar.',
      excessConfirm: 'Confirmar el exceso',
      undoLast: 'Deshacer último escaneo',
      undoing: 'Anulando…',
      undoDone: 'Escaneo anulado',
      undoDoneDetail: 'Se deshizo un escaneo de {{qty}} en {{sku}}: la línea vuelve a lo que marcan los escaneos que quedan.',
      undoTooMuch: 'Ese escaneo quitaría de más',
      undoTooMuchDetail: 'El último escaneo de {{sku}} es de {{qty}} y el exceso es {{excess}}: anularlo dejaría la línea por debajo de lo requerido. Corrígelo desde la ficha del kit.',
      undoFailed: 'No se pudo anular el escaneo',
      undoReason: 'Exceso deshecho desde el puesto de almacén',
      undoNoScan: 'No queda ningún escaneo que deshacer',
      undoNoScanDetail: '{{sku}} ya no tiene escaneos vivos: el exceso viene de una anulación o de otro puesto.',
      complete: 'Completar kit',
      completeRejected: 'No se pudo completar el kit',
      printLabel: 'Etiqueta de seguimiento',
      labelError: 'El kit se cerró, pero no se pudo abrir la etiqueta'
    }
  }
};

const en = {
  translation: {
    app: { name: 'Eurobath ERP', subtitle: 'Factory operations control', version: 'Phase 1' },
    impersonation: {
      viewingAs: 'Viewing as {{name}} ({{user}})',
      readOnly: 'Read only',
      minutesLeft_one: '{{count}} min left',
      minutesLeft_other: '{{count}} min left',
      back: 'Back to Administration',
      start: 'View as',
      dialogTitle: 'View the application as {{name}}',
      dialogHint: 'A read-only session opens with their permissions and station. You can return to Administration at any time.',
      terminal: 'Terminal',
      terminalAuto: 'Their station (automatic)',
      enter: 'Enter as this worker'
    },
    station: {
      endShift: 'End shift',
      endShiftConfirmShort: 'Tap again to end',
      endShiftConfirmTouch: 'Tap again to end',
      endShiftConfirmKey: 'Press Space again to end',
      nav: 'Station bar',
      connected: 'Online',
      offline: 'Offline',
      noTerminal: 'No terminal'
    },
    nav: {
      dashboard: 'Dashboard', operations: 'Operations', sales: 'Sales', salesOrders: 'Sales orders', customers: 'Customers', kits: 'Kits',
      packaging: 'Packaging', logistics: 'Logistics', warehouse: 'Warehouse', warehouseStation: 'Warehouse station', products: 'Products', families: 'Families',
      stock: 'Stock', purchasing: 'Purchasing', suppliers: 'Suppliers', invoices: 'Invoices', purchaseOrders: 'Purchase orders', treasury: 'Treasury', tariff: 'Tariff', currencies: 'Currencies', company: 'Company details',
      engineering: 'Engineering', models: 'Models & BOM', planning: 'Planning', admin: 'Administration',
      users: 'Users', terminals: 'Terminals', audit: 'Audit', settings: 'Settings'
    },
    actions: {
      new: 'New', save: 'Save', cancel: 'Cancel', edit: 'Edit', delete: 'Delete', search: 'Search',
      filter: 'Filter', refresh: 'Refresh', close: 'Close', confirm: 'Confirm', back: 'Back',
      print: 'Print', download: 'Download', view: 'View', validate: 'Validate', release: 'Release',
      scan: 'Scan', complete: 'Complete', run: 'Run', logout: 'Sign out', login: 'Sign in',
      add: 'Add', remove: 'Remove', apply: 'Apply', retry: 'Retry', upload: 'Upload',
      acknowledge: 'Acknowledge', resolve: 'Resolve', details: 'Details', actions: 'Actions',
      previous: 'Previous', next: 'Next', clear: 'Clear', language: 'Language', theme: 'Theme'
    },
    common: {
      loading: 'Loading…', noData: 'No results', all: 'All', total: 'Total', units: 'Units',
      quantity: 'Quantity', date: 'Date', status: 'Status', type: 'Type', name: 'Name', code: 'Code',
      notes: 'Notes', location: 'Location', supplier: 'Supplier', customer: 'Customer', model: 'Model',
      order: 'Order', kit: 'Kit', unit: 'Unit', price: 'Price', cost: 'Cost', stock: 'Stock',
      reserved: 'Reserved', available: 'Available', incoming: 'Incoming', min: 'Minimum', required: 'Required',
      scanned: 'Scanned', pending: 'Pending', optional: 'Optional', yes: 'Yes', no: 'No',
      page: 'Page', of: 'of', results: 'results', saved: 'Saved successfully',
      error: 'An error occurred', requiredField: 'Required field', dateFrom: 'From', dateTo: 'To'
    },
    login: {
      title: 'Sign in', subtitle: 'Enter your credentials to access the system.',
      user: 'Username or email', password: 'Password', terminal: 'Terminal', badge: 'Badge',
      withPassword: 'Username & password', withBadge: 'QR badge', badgeHint: 'Scan your personal badge',
      submit: 'Sign in', demo: 'Demo credentials',
      feature1: 'Full traceability per unit', feature2: 'Real-time stock, kits and packaging',
      feature3: 'MRP planning and shortage alerts', secure: 'Secure connection · audited session',
      error: 'Could not sign in'
    },
    dashboard: {
      title: 'Dashboard', subtitle: 'Real-time factory operations overview',
      openOrders: 'Open sales orders', pendingUnits: 'Units to prepare', inProduction: 'In production',
      shipmentsToday: 'Shipments today', stockValue: 'Stock value', criticalAlerts: 'Critical alerts',
      lowStock: 'Below minimum', pipeline: 'Sales order pipeline', production: 'Units created (14 days)',
      alerts: 'Planning alerts', activity: 'Recent activity', noActivity: 'No recent activity',
      viewPlanning: 'View planning'
    },
    kpis: { days14: 'Last 14 days', shift: 'Current shift', live: 'Live' },
    warehouse: {
      title: 'Warehouse station',
      subtitle: 'Pending kits, goods receipt and printing on a single vertical screen',
      queue: 'Preparation queue',
      pendingCount: '{{count}} queued',
      agedCount: '{{count}} overdue',
      ageAlert: 'Kit {{kit}} has been waiting {{hours}} h',
      ageAlertMany: '{{count}} kits passed the age threshold and are flagged in the queue',
      aged: 'overdue',
      empty: 'No pending kits',
      emptyHint: 'Units appear here as soon as an order releases them.',
      missingPieces: '{{count}} pieces pending',
      ofLines: '{{done}}/{{total}} lines ready',
      prepare: 'Prepare kit',
      pickHint: 'Pick a kit from the queue to prepare it.',
      shortcuts: 'Shortcuts',
      reception: 'Purchase receipt',
      printing: 'Label printing',
      back: 'Back to queue',
      age: 'Age',
      linesPending: '{{count}} pieces incomplete',
      scanLabel: 'Scan the piece EAN or SKU',
      scanPlaceholder: 'EAN or SKU…',
      pieces: 'Kit pieces',
      ready: 'Complete',
      missingQty: '{{missing}} missing',
      lineComplete: 'Piece complete',
      linePartial: 'Added, units still missing',
      scannedLine: '{{sku}} · {{scanned}} / {{required}} · {{pending}} missing',
      scanRejected: 'Scan rejected',
      scanExcess: '{{message}} Required: {{required}} · missing: {{pending}} ({{sku}})',
      invalidQty: 'Invalid quantity: type a number greater than zero (a comma works too, 2.4).',
      overScanned: 'Scanned above the required quantity',
      overScannedDetail: '{{sku}}: {{scanned}} of {{required}}. Check the piece before continuing.',
      excessShort: '+{{qty}} over',
      excessBlockTitle: '{{count}} piece(s) scanned above the required quantity',
      excessBlockDetail: 'Closing the kit will consume {{qty}} extra units of stock. Check the flagged pieces before continuing.',
      excessConfirm: 'Confirm the excess',
      undoLast: 'Undo last scan',
      undoing: 'Voiding…',
      undoDone: 'Scan voided',
      undoDoneDetail: 'A scan of {{qty}} on {{sku}} was undone: the line goes back to what the remaining scans add up to.',
      undoTooMuch: 'That scan would take too much away',
      undoTooMuchDetail: 'The last scan of {{sku}} is {{qty}} and the excess is {{excess}}: undoing it would leave the line below the required quantity. Fix it from the kit sheet.',
      undoFailed: 'The scan could not be voided',
      undoReason: 'Excess undone from the warehouse station',
      undoNoScan: 'There is no scan left to undo',
      undoNoScanDetail: '{{sku}} has no live scans left: the excess comes from a void or from another station.',
      complete: 'Complete kit',
      completeRejected: 'The kit could not be completed',
      printLabel: 'Tracking label',
      labelError: 'The kit was closed, but the label could not be opened'
    }
  }
};

const stored = localStorage.getItem('eb_locale');
const locale = stored === 'en' || stored === 'es' ? stored : 'es';

void i18n.use(initReactI18next).init({
  resources: { es, en },
  lng: locale,
  fallbackLng: 'es',
  interpolation: { escapeValue: false }
});

document.documentElement.lang = locale;

export function setLocale(next: 'es' | 'en') {
  localStorage.setItem('eb_locale', next);
  document.documentElement.lang = next;
  void i18n.changeLanguage(next);
}

export default i18n;
